<template>
  <el-form label-position="top" class="filter-form">
    <el-row type="flex" style="flex-wrap: wrap" :gutter="10">
      <el-col :lg="7" :xl="5" style="margin-bottom: 10px">
        <el-card shadow="never">
          <el-form-item label="Creation date">
            <el-date-picker
                :value="date"
                type="daterange"
                format="MMM dd, yyyy"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                :editable="false"
                :clearable="true"
                style="width: 100%"
                @input="dateHandler($event)">
            </el-date-picker>
          </el-form-item
          >
        </el-card>
      </el-col>
      <el-col :lg="16" :xl="16" style="margin-bottom: 10px">
        <el-card shadow="never">
          <el-form-item label="Filter">
            <el-row :gutter="10">
              <el-col :lg="6">
                <el-input
                    v-model="value.search.client_name"
                    clearable
                    placeholder="Enter client name"
                    @input="updateDebounced('client_name', $event)">
                </el-input>
              </el-col>
              <el-col :lg="6">
                <el-input
                    v-model="value.account_id"
                    clearable
                    placeholder="Enter client ID"
                    @input="updateDebounced('account_id', $event)">
                </el-input>
              </el-col>
              <el-col :lg="6">
                <el-input
                    v-model="value.message_uuid"
                    clearable
                    placeholder="Enter uuid"
                    @input="updateDebounced('message_uuid', $event)">
                </el-input>
              </el-col>
              <el-col :lg="6">
                <el-select
                  placeholder="Status"
                  v-model="value.status"
                  @input="updateDebounced('status', $event)"
                  clearable>
                  <el-option
                    v-for="item in [{title: 'Active', value: 0}, {title: 'Closed', value: 1}]"
                    :value="item.value"
                    :label="item.title"
                    :key="item.value"
                  >
                    {{ item.title }}
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-card>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import {mapGetters} from "vuex";
import debounce from "lodash.debounce";
import moment from "moment";

export default {
  name: "filters",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({dictionary: "dictionary"}),
    date() {
      return [
        moment(this.value.created_at.from).format("YYYY-MM-DD"),
        moment(this.value.created_at.to).format("YYYY-MM-DD"),
      ];
    },
  },
  methods: {
    update(key, value) {
      this.$emit("input", {...this.value, [key]: value});
    },
    updateDebounced: debounce(function () {
      this.$emit("input", this.value);
    }, 500),
    dateHandler(date) {
      if (!date) {
        this.update("created_at", {from: null, to: null});
        return;
      }
      const value = {
        from: date[0] + " 00:00",
        to: date[1] + " 23:59",
      };

      this.update("created_at", value);
    },
  },
};
</script>

<style scoped></style>
